/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React from 'react'
import ProcessBatch from '@/components/batches/ProcessBatch'
import ModalBodyProcessListingBatch from './components/ModalBodyProcessListingBatch'
import { columnsListingTable } from './handlers'
import { GENERAL_ERROR } from '@/configs/strings/message'

const AcquireLicenseForm = ({
  hasAlert,
  hasFormErrors,
  isHiddenForm,
  sendData,
  setHasAlert,
  totalAssets
}) => {
  const costPerAsset = 0.75
  const totalCost = +totalAssets * +costPerAsset
  const rowTable = {
    totalCost,
    costPerAsset,
    numberAssets: totalAssets
  }

  return (
    <ProcessBatch
      alertMessage={GENERAL_ERROR}
      alertStatus="error"
      bodyModal={
        () => <ModalBodyProcessListingBatch
          totalAssets={totalAssets}
          costPerAsset={costPerAsset}
        />
      }
      columnsTable={columnsListingTable}
      hasAlert={hasAlert}
      hasFormErrors={hasFormErrors}
      isHiddenContinueButton={isHiddenForm}
      labelContinue="Accept terms and list Assets"
      labelModalOnProcess="List Assets"
      onProcess={sendData}
      rowTable={rowTable}
      setHasAlert={setHasAlert}
      isInvalid={hasFormErrors}
      titleModal="List Multiple Assets"
    />
  )
}

export default AcquireLicenseForm
